document.addEventListener('DOMContentLoaded',function(){
  const toggle=document.querySelector('[data-menu-toggle]');
  const mobile=document.querySelector('[data-mobile-nav]');
  if(toggle&&mobile){
    toggle.addEventListener('click',()=>{
      const open=mobile.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded',open?'true':'false');
    });
    mobile.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{
      mobile.classList.remove('is-open');
      toggle.setAttribute('aria-expanded','false');
    }));
  }
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
    document.querySelectorAll('.mv-reveal').forEach(el=>observer.observe(el));
  }else{
    document.querySelectorAll('.mv-reveal').forEach(el=>el.classList.add('is-visible'));
  }
});